import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useLabel = (siteAssessmentId, pricingVersion) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [labelText, setLabelText] = useState('');
  const [labelError, setLabelError] = useState(false);
  const [labels, setLabels] = useState([]);
  const [currentLable, setCurrentLable] = useState('');

  const open = Boolean(anchorEl);

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddLabel = async (siteAssessmentId, pricingVersion, label) => {
    const payload = {
      siteAssessmentID: siteAssessmentId,
      pricingVersion: pricingVersion,
      timberPricingLabel: label, // ✅ use argument
    };

    try {
      const response = await customAxios.post('/Ops/EditTimberPricingLabel', payload, { headers: authHeader() });

      setCurrentLable(label);
      setLabelText('');
      setAnchorEl(null);
      setLabelError(false);
    } catch (err) {
      console.error('Error updating label:', err);
      setLabelError(true);
    }
  };

  useEffect(() => {
    const fetchLabel = async () => {
      try {
        const url = `/Ops/GetTimberPricing?siteAssessmentID=${siteAssessmentId}&sPNumber=&pricingVersion=${pricingVersion}`;
        const response = await customAxios.get(url, { headers: authHeader() });

        if (response?.data?.length > 0) {
          setCurrentLable(response.data[0].timberPricingLabel || '');
        }
      } catch (error) {
        console.error('Error fetching label:', error);
      }
    };

    if (siteAssessmentId && pricingVersion) {
      fetchLabel();
    }
  }, [siteAssessmentId, pricingVersion]);

  return {
    anchorEl,
    setAnchorEl,
    labelText,
    setLabelText,
    open,
    handleMenuClick,
    handleClose,
    handleAddLabel,
    setLabelError,
    labelError,
    setLabels,
    labels,
    currentLable,
  };
};

export default useLabel;
